import i18n from "@/i18n";

export const channelsFields = [
    {
        key: "name",
        label: i18n.t("channels.name"),
        sortable: true
    },
    {
        key: "actions",
        label: ""
    },
    {
        key: "drag",
        label: "",
        class: "draggable-btn-cell"
    }
];
